module.exports = __webpack_public_path__ + "static/img/sample-pic4.cfbf1d6b.png";